import { WeatherLoader } from '@fe/weather';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getWorker } from '../../../client/worker-container';
import { MessageType } from '../../../services/actor-messages';
import { RootState } from '../slices';

export const startRecording = createAsyncThunk(
    'global/start-recording',
    async (params: { recordingName?: string; automated?: boolean }, thunkApi) => {
        const result = await getWorker().actor.sendAsync({
            type: MessageType.startRecording,
            data: { name: params.recordingName, automated: params.automated }
        });

        if (!result.ok) {
            return thunkApi.rejectWithValue(result.reason);
        }

        if (result.type === 'file') {
            await WeatherLoader.setRecordingDirectory(result.directoryHandle);

            const state = thunkApi.getState() as RootState;
            const all = state.weather.live.products;
            const toRecord = state.settings.alwaysLoadWeather.map((x) => all.find((y) => y.id === x.id)).filter((x) => !!x);

            await WeatherLoader.record(
                toRecord.map((product) => ({
                    frame: 'all',
                    product: product
                }))
            );
        }
        return thunkApi.fulfillWithValue({ fileName: result.fileName });
    }
);

export const stopRecording = createAsyncThunk('global/stop-recording', async () => {
    await getWorker().actor.sendAsync({ type: MessageType.stopRecording });
    await WeatherLoader.setRecordingDirectory(null);
});
